import { FormatType } from '@/shared/hooks';

export const getStep = (formatType: FormatType) => {
  return formatType === FormatType.FLOAT ? 0.01 : 1;
};
